module.exports = __webpack_public_path__ + "static/media/vuex.1b5fdf14.PNG";